module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-2@3x.jpg?00480a23";